import { createControlId } from '@avantia/questionset-model';
import { CSSProperties, ReactElement } from 'react';
import { HpOnMouseEvent } from '../../../types/inputControlTypes';

export function mergeStyles(...styles: CSSProperties[]): CSSProperties {
  return Object.assign({}, ...styles);
}

export interface HpCompileQuestionArgs {
  answerText: string;
  className: string;
  editControl: ReactElement;
  id: string;
  onClick: HpOnMouseEvent;
  questionText: string;
  style?: CSSProperties;
}

export function compileQuestion({
  id,
  onClick,
  style,
  questionText,
  answerText,
  editControl,
  className
}: HpCompileQuestionArgs): string | JSX.Element {
  const re = /{{value}}/;
  const ms = re.exec(questionText);
  let before: string | undefined;
  let after: string | undefined;
  let token: string | undefined;
  let result: string | ReactElement = questionText;
  if (ms && ms.length) {
    token = ms[0];
    before = questionText.substring(0, ms.index);
    after = questionText.substring(ms.index + token.length);
    result = (
      <span>
        <span>{before}</span>
        <a
          href="#"
          id={createControlId({ questionId: id, key: 'link', options: { ignorePrefix: true } })}
          onClick={onClick as any}
          style={style}
          className={className}
        >
          {answerText || '<No Answer>'}
        </a>
        {editControl}
        <span>{after}</span>
      </span>
    );
  }

  return result;
}
